/* import __COLOCATED_TEMPLATE__ from './standalone-content-source-usage-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    usage: {
      agent: number;
      all: number;
      copilot: number;
    };
    isDisabled: boolean;
    isEligibleForChatbot: boolean;
    isEligibleForCopilot: boolean;
    tooltipText?: string;
  };
  Blocks: {
    default: [];
  };
  Element: Element;
}

const StandaloneContentSourceUsageTooltip = templateOnlyComponent<Signature>();
export default StandaloneContentSourceUsageTooltip;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::StandaloneContentSourceUsageTooltip': typeof StandaloneContentSourceUsageTooltip;
  }
}
